import Button from 'src/components/Button';

import { PlacementDocument } from './singleStudent.types';
import { useDownloadBlobMutation } from './singleStudentApi';
import { getDocumentTypeName } from './StudentDocuments.utils';

type StudentDocumentCardProps = {
  document: PlacementDocument;
};

export const StudentDocumentCard = ({ document }: StudentDocumentCardProps) => {
  const [downloadBlob, { isLoading }] = useDownloadBlobMutation();

  const handleDownload = async () => {
    try {
      await downloadBlob({
        name: document.name,
        contentType: document.contentType,
        url: document.url,
      }).unwrap();
    } catch (error) {
      console.error('Error downloading document:', error);
    }
  };

  return (
    <div className="flex w-full items-center gap-4 rounded-lg bg-neutral-white p-4 shadow-elevation-2">
      <div className="flex flex-1 flex-col gap-2">
        <p className="text-body-xs-desktop text-neutral-300">
          {getDocumentTypeName(document.type)}
        </p>
        <p className="text-body-sm-desktop font-medium text-neutral-100">{document.name}</p>
      </div>
      <Button preset="tertiary" size="md" onClick={handleDownload} disabled={isLoading}>
        {isLoading ? 'Downloading...' : 'Download'}
      </Button>
    </div>
  );
};
